import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {connect} from "react-redux";
import {compose} from "recompose";
import {RESOURCES as loyaltyResources} from '../fuseLoyaltyResourceMap';
import {compareValues, convertDateToLocalString} from '../shared/functions';
import {checkTokenStatus} from '../shared/tokenFunctions';
import TransactionTableHeaderRow from '../components/TransactionTableHeaderRow';
import TransactionTableRow from '../components/TransactionTableRow';
import {Card, CardHeader, CardText} from 'material-ui/Card';
import {
    Table,
    TableHeader,
    TableRow,
    TableRowColumn,
    TableBody
} from 'material-ui';
import FuseTheme from "../global/theme";

/**
 * A component for generating rows of TransactionTableRows for a Loyalty Account.
 *
 */
class TransactionTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            accountId: '',
            transactionList: {},
        };
    }

    componentWillMount() {
        this.setState({
            accountId: this.props.accountId,
        });
        this.fetchTransactions();
    }

    // Get all Transactions for this Loyalty Account
    fetchTransactions() {
        const params = {
            filter: {
                account_id: this.props.accountId
            },
        };
        const resource = loyaltyResources.CustomerLedgerEntries.GET_LIST(params);

        // Retrieve the data and store results
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        this.processTransactions(result.data.payload);
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    processTransactions = (list) => {
        list.forEach(function (item, idx) {
            item.modified_local_str = convertDateToLocalString(item.modified, true);
        });
        this.setState({
            transactionList: list
        });
    };

    // Create table rows of Transaction items
    makeTransactionTable = (list) => {
        if (!list || !list.length) {
            return (
                <TableRow>
                    <TableRowColumn>No Transactions</TableRowColumn>
                </TableRow>
            )
        }
        list.sort(compareValues('modified', 'asc'));
        return (
            list.map((item, index) => (
                <TransactionTableRow
                    key={item.lluuid.toString() + index}
                    data={item}
                />
            ))
        )
    };

    render() {
        const styles = {
            fieldDescription: {
                display: 'block',
                width: '100%',
                fontSize: '14px',
                color: FuseTheme.palette.lightTextColor,
                margin: '0 0 1em 0',
            },
            tableCard: {display: 'block', margin: '1em 0 0 0'},
        };

        return (
            <Card style={styles.tableCard} initiallyExpanded>
                <CardHeader title="Transactions" actAsExpander={true} showExpandableButton={true}/>
                <CardText expandable={true}>
                    <span style={styles.fieldDescription}>Transactions for this Loyalty Account.</span>
                    <span style={styles.fieldDescription}>
                    When Loyalty Account is looked up via the Admin or POS, Customer’s Rank/Reward points may be zeroed
                    out when the customer’s latest loyalty ledger entry is passed the number of days set by the Loyalty
                    Rank’s “Reward Point Days Valid”.
                    </span>
                    <Table selectable={false} multiSelectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TransactionTableHeaderRow/>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {[...this.makeTransactionTable(this.state.transactionList)]}
                        </TableBody>
                    </Table>
                </CardText>
            </Card>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let form = state.form['record-form'];
    if (form && form.values) {
        return {
            accountId: ownProps.accountId,
        }
    }
    return {}
};

TransactionTable.propTypes = {
    addField: PropTypes.bool,
    accountId: PropTypes.string,
};

TransactionTable.defaultProps = {
    addField: true,
    accountId: null,
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(TransactionTable);



// WEBPACK FOOTER //
// ./src/Fuse/components/TransactionTable.js